import { ModalFormRegisterProduct } from '../../../components/forms/product/modalFormRegisterProduct'
import createField from '../../../utils/factory/createField'
import {
  faList,
  faMapMarkerAlt,
  faPlus,
  faCalendarDays,
  faFileLines,
  faHashtag,
  faBuilding,
  faUser,
  faCalendarAlt,
  faFileInvoice,
  faIndustry,
  faCalendarDay,
  faMoneyCheck,
  faMoneyBill1Wave,
  faLocationDot, // ⬅️ Adicionado para os endereços
} from '@fortawesome/free-solid-svg-icons'

export const transactionFields = [
  {
    section: 'Dados da Transação',
    fields: [
      createField({
        id: 'transaction.transaction_type_id',
        label: 'Tipo de Transação',
        type: 'select',
        isMulti: false,
        disabled: true,
        isClearable: false,
        placeholder: 'Selecione o tipo de transação',
        icon: faList,
      }),
      createField({
        id: 'transaction.transaction_date',
        label: 'Data da Transação',
        placeholder: 'Selecione a data da transação',
        type: 'date',
        icon: faCalendarDays,
      }),
      createField({
        id: 'transaction.doc_type_id',
        label: 'Tipo de Documento',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o tipo de documento',
        icon: faList,
      }),
      createField({
        id: 'transaction.supplier_id',
        label: 'Fornecedor',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o fornecedor',
        icon: faList,
      }),
      createField({
        id: 'transaction.doc_number',
        label: 'Número do Documento',
        type: 'text',
        placeholder: 'Selecione o número do documento',
        icon: faHashtag,
      }),
      createField({
        id: 'transaction.amount_total',
        label: 'Valor total dos Itens',
        type: 'number',
        isNumericFormat: true,
        placeholder: 'Insira o valor total dos itens',
        icon: faMoneyCheck,
      }),
      createField({
        id: 'transaction.amount_discount',
        label: 'Desconto da Nota',
        type: 'number',
        defaultValue: 0,
        isNumericFormat: true,
        placeholder: 'Insira o desconto da nota',
        icon: faMoneyBill1Wave,
      }),
      createField({
        id: 'transaction.doc_date',
        label: 'Data do Documento',
        type: 'date',
        placeholder: 'Selecione a data do documento',
        icon: faCalendarDays,
      }),
      createField({
        id: 'transaction.purchase_date',
        label: 'Data da Compra',
        type: 'date',
        placeholder: 'Selecione a data da compra',
        icon: faCalendarDays,
      }),
      createField({
        id: 'transaction.asset_type',
        label: 'Equipamento ou Insumo?',
        type: 'multi-select',
        isMulti: true,
        isClearable: true,
        placeholder: 'Selecione o tipo de equipamento ou insumo',
        icon: faList,
      }),

      // 🔄 ALTERADO: Nome do campo e label para clareza
      createField({
        id: 'transaction.sender_id',
        label: 'Organização de Origem',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione a organização de origem',
        icon: faBuilding,
      }),

      // 🔄 ALTERADO: ID do campo para bater com o backend (sender_address_id)
      createField({
        id: 'transaction.sender_address_id',
        label: 'Endereço de Origem',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o endereço de origem',
        icon: faLocationDot,
      }),

      createField({
        id: 'transaction.receiver_id',
        label: 'Organização de Destino',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione a organização de destino',
        icon: faBuilding,
      }),

      // 🆕 NOVO: Endereço de destino da transferência
      createField({
        id: 'transaction.receiver_address_id',
        label: 'Endereço de Destino',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o endereço de destino',
        icon: faLocationDot,
        fullWidth: false,
      }),

      createField({
        id: 'transaction.customer_id',
        label: 'Cliente Destinatário',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o cliente destinatário',
        icon: faUser,
        fullWidth: true,
      }),
      createField({
        id: 'transaction.details',
        label: 'Detalhes',
        type: 'textarea',
        placeholder: 'Digite os detalhes da transação',
        icon: faFileLines,
        fullWidth: true,
      }),
    ],
  },
  {
    section: 'Produtos',
    array: true,
    fields: [
      createField({
        id: 'items.product_id',
        label: 'Produto',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o produto',
        icon: faList,
        fullWidth: true,
        options: [
          {
            type: 'modal',
            icon: faPlus,
            tooltip: 'Cadastre um novo produto',
            children: ModalFormRegisterProduct,
          },
        ],
      }),
      createField({
        id: 'items.product_item_id',
        label: 'Item do Produto',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o item do produto',
        icon: faList,
        fullWidth: true,
      }),
      createField({
        id: 'items.category_id',
        label: 'Categoria',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione a categoria',
        icon: faList,
      }),
      createField({
        id: 'items.condition_id',
        label: 'Condição',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione a condição',
        icon: faList,
      }),
      createField({
        id: 'items.address_id',
        label: 'Endereço de Destino do Item',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o endereço',
        icon: faMapMarkerAlt,
        disabled: true, // Desabilitado para edição, pois o endereço de destino é definido pela transação
      }),
      createField({
        id: 'items.location_id',
        label: 'Localização',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione a localização',
        icon: faMapMarkerAlt,
        notRequired: true,
      }),
      createField({
        id: 'items.warranty_date',
        label: 'Data de Garantia',
        placeholder: 'Selecione a data de garantia',
        type: 'date',
        formatType: 'date',
        icon: faCalendarDays,
        fullWidth: true,
      }),
      createField({
        id: 'items.unit_cost',
        label: 'Custo Unitário',
        type: 'number',
        formatType: 'currency',
        isNumericFormat: true,
        placeholder: 'Selecione o custo unitário',
        icon: faMoneyCheck,
      }),
      createField({
        id: 'items.quantity',
        label: 'Quantidade',
        type: 'number',
        formatType: 'integer',
        isNumericFormat: true,
        placeholder: 'Selecione a quantidade',
        icon: faList,
      }),
    ],
  },
  {
    section: 'Equipamentos',
    array: true,
    fields: [
      createField({
        id: 'equipments.equipment_id',
        label: 'Equipamento',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o equipamento',
        icon: faList,
        fullWidth: true,
      }),
      createField({
        id: 'equipments.address_id',
        label: 'Endereço de Destino do Equipamento',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o endereço',
        icon: faMapMarkerAlt,
      }),
      createField({
        id: 'equipments.location_id',
        label: 'Localização',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione a localização',
        icon: faMapMarkerAlt,
        notRequired: true,
      }),
    ],
  },
]

export const editTransactionFields = [
  {
    section: 'Dados da Transação',
    fields: [
      createField({
        id: 'transaction.transaction_type_id',
        label: 'Tipo de Transação',
        type: 'select',
        isMulti: false,
        isClearable: false,
        disabled: true,
        placeholder: 'Selecione o tipo de transação',
        icon: faList,
      }),
      createField({
        id: 'transaction.transaction_date',
        label: 'Data da Transação',
        type: 'date',
        icon: faCalendarDays,
      }),
      createField({
        id: 'transaction.doc_type_id',
        label: 'Tipo de Documento',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o tipo de documento',
        icon: faList,
      }),
      createField({
        id: 'transaction.supplier_id',
        label: 'Fornecedor',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o fornecedor',
        icon: faList,
      }),
      createField({
        id: 'transaction.doc_number',
        label: 'Número do Documento',
        type: 'text',
        placeholder: 'Selecione o número do documento',
        icon: faHashtag,
      }),
      createField({
        id: 'transaction.amount_total',
        label: 'Valor total dos Itens',
        type: 'number',
        formatType: 'currency',
        isNumericFormat: true,
        placeholder: 'Insira o valor total dos itens',
        icon: faMoneyCheck,
      }),
      createField({
        id: 'transaction.amount_discount',
        label: 'Desconto da Nota',
        type: 'number',
        formatType: 'currency',
        isNumericFormat: true,
        placeholder: 'Insira o desconto da nota',
        icon: faMoneyBill1Wave,
      }),
      createField({
        id: 'transaction.doc_date',
        label: 'Data do Documento',
        type: 'date',
        placeholder: 'Selecione a data do documento',
        icon: faCalendarDays,
      }),
      createField({
        id: 'transaction.purchase_date',
        label: 'Data da Compra',
        type: 'date',
        placeholder: 'Selecione a data da compra',
        icon: faCalendarDays,
      }),
      createField({
        id: 'transaction.asset_type',
        label: 'Equipamento ou Insumo?',
        type: 'select',
        isMulti: true,
        isClearable: true,
        placeholder: 'Selecione o tipo de equipamento ou insumo',
        icon: faList,
      }),
      createField({
        id: 'transaction.sender_id',
        label: 'Organização de Origem',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione a organização de origem',
        icon: faBuilding,
      }),
      // 🆕 NOVO na Edição
      createField({
        id: 'transaction.sender_address_id',
        label: 'Endereço de Origem',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o endereço de origem',
        icon: faLocationDot,
      }),
      createField({
        id: 'transaction.receiver_id',
        label: 'Organização de Destino',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione a organização de destino',
        icon: faBuilding,
      }),
      // 🆕 NOVO na Edição
      createField({
        id: 'transaction.receiver_address_id',
        label: 'Endereço de Destino',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o endereço de destino',
        icon: faLocationDot,
        fullWidth: false,
      }),
      createField({
        id: 'transaction.customer_id',
        label: 'Cliente',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o cliente',
        icon: faUser,
      }),
      createField({
        id: 'transaction.buyer_id',
        label: 'Comprador',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o comprador',
        icon: faBuilding,
      }),
      createField({
        id: 'transaction.details',
        label: 'Detalhes',
        type: 'textarea',
        placeholder: 'Digite os detalhes da transação',
        icon: faFileLines,
        fullWidth: true,
      }),
    ],
  },
  // ... (Seções de Insumos e Equipamentos permanecem iguais ao original)
  {
    section: 'Insumos',
    array: true,
    fields: [
      createField({
        id: 'items.product_id',
        label: 'Produto',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o produto',
        icon: faList,
        fullWidth: true,
      }),
      createField({
        id: 'items.product_item_id',
        label: 'Item do Produto',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o item do produto',
        icon: faList,
        fullWidth: true,
      }),
      createField({
        id: 'items.category_id',
        label: 'Categoria',
        type: 'select',
        isMulti: false,
        isClearable: true,
        disabled: true,
        placeholder: 'Selecione a categoria',
        icon: faList,
      }),
      createField({
        id: 'items.condition_id',
        label: 'Condição',
        type: 'select',
        isMulti: false,
        isClearable: true,
        disabled: true,
        placeholder: 'Selecione a condição',
        icon: faList,
      }),
      createField({
        id: 'items.address_id',
        label: 'Endereço',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o endereço',
        icon: faMapMarkerAlt,
      }),
      createField({
        id: 'items.location_id',
        label: 'Localização',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione a localização',
        icon: faMapMarkerAlt,
        notRequired: true,
      }),
      createField({
        id: 'items.warranty_date',
        label: 'Data de Garantia',
        type: 'date',
        icon: faCalendarDays,
        fullWidth: true,
      }),
      createField({
        id: 'items.unit_cost',
        label: 'Custo Unitário',
        type: 'number',
        isNumericFormat: true,
        placeholder: 'Selecione o custo unitário',
        icon: faMoneyCheck,
      }),
      createField({
        id: 'items.quantity',
        label: 'Quantidade',
        type: 'number',
        isNumericFormat: true,
        placeholder: 'Selecione a quantidade',
        icon: faList,
      }),
    ],
  },
  {
    section: 'Equipamentos',
    array: true,
    fields: [
      createField({
        id: 'equipments.equipment_id',
        label: 'Equipamento',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o equipamento',
        icon: faList,
        fullWidth: true,
      }),
      createField({
        id: 'equipments.address_id',
        label: 'Endereço',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione o endereço',
        icon: faMapMarkerAlt,
      }),
      createField({
        id: 'equipments.location_id',
        label: 'Localização',
        type: 'select',
        isMulti: false,
        isClearable: true,
        placeholder: 'Selecione a localização',
        icon: faMapMarkerAlt,
        notRequired: true,
      }),
    ],
  },
]

export const detailsTransactionFields = [
  {
    section: 'Dados da Transação',
    fields: [
      createField({
        id: 'transaction.transaction_type',
        label: 'Tipo de Transação',
        type: 'text',
        icon: faList,
        disabled: true,
      }),
      createField({
        id: 'transaction.sender',
        label: 'Organização de Origem',
        type: 'text',
        icon: faBuilding,
        disabled: true,
      }),
      // 🆕 NOVO nos Detalhes
      createField({
        id: 'transaction.sender_address', // O backend deve retornar isso no with('senderAddress')
        label: 'Endereço de Origem',
        type: 'text',
        icon: faLocationDot,
        disabled: true,
      }),
      createField({
        id: 'transaction.customer',
        label: 'Cliente',
        type: 'text',
        icon: faUser,
        disabled: true,
      }),
      createField({
        id: 'transaction.receiver',
        label: 'Organização de Destino',
        type: 'text',
        icon: faBuilding,
        disabled: true,
      }),
      // 🆕 NOVO nos Detalhes
      createField({
        id: 'transaction.receiver_address', // O backend deve retornar isso no with('receiverAddress')
        label: 'Endereço de Destino',
        type: 'text',
        icon: faLocationDot,
        disabled: true,
      }),
      createField({
        id: 'transaction.transaction_date',
        label: 'Data da Transação',
        type: 'text',
        icon: faCalendarAlt,
        disabled: true,
      }),
      createField({
        id: 'transaction.user',
        label: 'Criado Por',
        type: 'text',
        icon: faUser,
        disabled: true,
      }),
      createField({
        id: 'transaction.doc_type',
        label: 'Tipo de Documento',
        type: 'text',
        icon: faFileInvoice,
        disabled: true,
      }),
      createField({
        id: 'transaction.supplier',
        label: 'Fornecedor',
        type: 'text',
        icon: faIndustry,
        disabled: true,
      }),
      createField({
        id: 'transaction.doc_number',
        label: 'Número do Documento',
        type: 'text',
        icon: faFileInvoice,
        disabled: true,
      }),
      createField({
        id: 'transaction.amount_total',
        label: 'Valor total dos Itens',
        type: 'number',
        icon: faMoneyCheck,
      }),
      createField({
        id: 'transaction.amount_discount',
        label: 'Desconto da Nota',
        type: 'number',
        disabled: true,
        icon: faMoneyBill1Wave,
      }),
      createField({
        id: 'transaction.doc_date',
        label: 'Data do Documento',
        type: 'text',
        icon: faCalendarDay,
        disabled: true,
      }),
      createField({
        id: 'transaction.purchase_date',
        label: 'Data da Compra',
        type: 'text',
        icon: faCalendarDay,
        disabled: true,
      }),
      createField({
        id: 'transaction.buyer',
        label: 'Comprador',
        type: 'text',
        icon: faMoneyCheck,
        fullWidth: true,
        disabled: true,
      }),
      createField({
        id: 'transaction.details',
        label: 'Detalhes',
        type: 'textarea',
        fullWidth: true,
        disabled: true,
      }),
    ],
  },
]
